import { bluetoothConstants } from "../constants/bluetooth.constants";

export const handleBluetoothState = (status: string) => (
    { type: bluetoothConstants.UPDATE_BLUETOOTH_STATUS, data: status }
);

export const bluetoothConnection = (connected: boolean) => (
    { type: bluetoothConstants.BLUETOOTH_CONNECTION , data: connected }
)